/* Rescuevation · Mactronic Flagger Premium (rescu-flp-*), 19.10.2026

   Bewegung ist ADDITIV: Ohne JavaScript, bei reduzierter Bewegung und wenn ein
   Beobachter nie auslöst, steht jedes Element im fertigen Zustand. Dieses Script
   legt nur einmalige Keyframe-Läufe darüber (Klasse flp-go, nach animationend
   wieder entfernt).

   Kaufen: /cart/add.js, danach die Warenkorb-Schublade. Die Section-Liste kommt
   von der Schublade selbst (getSectionsToRender), weil die Live-Schublade b4c
   andere Sections rendert als Dawns Standard. */
(function () {
  'use strict';
  if (window.__rflp) return;
  window.__rflp = true;

  var doc = document.documentElement;
  doc.classList.add('flp-js');

  var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hatIO = 'IntersectionObserver' in window;
  var zahlFmt = new Intl.NumberFormat('de-DE');
  var geldFmt = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  var vh = function () { return window.innerHeight || doc.clientHeight; };
  var alle = function (wurzel, sel) { return Array.prototype.slice.call(wurzel.querySelectorAll(sel)); };
  var imBild = function (el) { var r = el.getBoundingClientRect(); return r.top < vh() - 40 && r.bottom > 0; };
  var geld = function (cent) { return geldFmt.format(cent / 100) + ' €'; };
  var brutto = function (cent) { return Math.round(cent * 1.19); };

  /* ---------- Einmalige Läufe ---------- */

  function einmal(el, klasse, dauer) {
    klasse = klasse || 'flp-go';
    var schluessel = '__flp_' + klasse;
    if (el[schluessel]) return;
    el[schluessel] = true;
    el.classList.add(klasse);
    var fertig = false;
    var ende = function (e) {
      if (fertig) return;
      if (e && e.target !== el) return;
      fertig = true;
      el.classList.remove(klasse);
      el[schluessel] = false;
      el.removeEventListener('animationend', ende);
    };
    el.addEventListener('animationend', ende);
    setTimeout(function () { ende(); }, dauer || 2600);
  }

  function tick(el) {
    if (!el || ruhig) return;
    el.classList.remove('flp-tick');
    void el.offsetWidth;
    el.classList.add('flp-tick');
    setTimeout(function () { el.classList.remove('flp-tick'); }, 600);
  }

  function zuenden(el) {
    if (!el || ruhig) return;
    el.classList.remove('flp-zuendet');
    void el.getBoundingClientRect();
    el.classList.add('flp-zuendet');
    clearTimeout(el.__flpZ);
    el.__flpZ = setTimeout(function () { el.classList.remove('flp-zuendet'); }, 900);
  }

  function staffeln(liste) {
    var gruppen = new Map();
    liste.forEach(function (el) {
      var g = el.parentElement;
      var n = gruppen.get(g) || 0;
      el.style.setProperty('--flp-d', Math.min(n * 90, 540) + 'ms');
      gruppen.set(g, n + 1);
    });
  }

  function einblenden() {
    if (ruhig || !hatIO) return;
    var els = alle(document, '.flp [data-flp-in]');
    staffeln(els);
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        einmal(e.target, 'flp-go', 1900);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) {
      if (el.hasAttribute('data-flp-sofort')) { einmal(el, 'flp-go', 1900); return; }
      if (imBild(el)) return;
      io.observe(el);
    });

    var linien = alle(document, '.flp [data-flp-linie]');
    var io2 = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (!e.isIntersecting) return;
        io2.unobserve(e.target);
        einmal(e.target, 'flp-linie-go', 2200);
      });
    }, { rootMargin: '0px 0px -15% 0px' });
    linien.forEach(function (el) { if (!imBild(el)) io2.observe(el); });
  }

  /* ---------- Kennzahlen zählen einmal hoch ---------- */

  function zaehle(el) {
    var roh = String(el.getAttribute('data-flp-zahl'));
    if (!/^\d+$/.test(roh)) return;
    var ziel = parseInt(roh, 10);
    if (!ziel) return;
    var endText = el.textContent;
    var t0 = null;
    var dauer = ziel >= 100 ? 1500 : 1100;
    var schritt = function (t) {
      if (!t0) t0 = t;
      var p = Math.min(1, (t - t0) / dauer);
      var w = 1 - Math.pow(1 - p, 4);
      el.textContent = zahlFmt.format(Math.round(ziel * w));
      if (p < 1) requestAnimationFrame(schritt); else el.textContent = endText;
    };
    el.textContent = '0';
    requestAnimationFrame(schritt);
  }

  function zaehlen() {
    if (ruhig || !hatIO) return;
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        zaehle(e.target);
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    alle(document, '.flp [data-flp-zahl]').forEach(function (el) { io.observe(el); });
  }

  /* ---------- Kaufbereich: beide Spalten kleben ---------- */

  function kleben() {
    alle(document, '[data-flp-kauf]').forEach(function (sec) {
      var spalten = alle(sec, '.flp-kauf__galerie, .flp-kauf__spalte');
      var oben = 24, unten = 24;
      function setzen() {
        spalten.forEach(function (el) {
          var h = el.offsetHeight;
          el.style.setProperty('--klebe', Math.min(oben, vh() - h - unten) + 'px');
        });
      }
      setzen();
      window.addEventListener('resize', setzen, { passive: true });
      if ('ResizeObserver' in window) {
        var ro = new ResizeObserver(function () { setzen(); });
        spalten.forEach(function (el) { ro.observe(el); });
      }
    });
  }

  /* ---------- Galerie und Lupe ---------- */

  var galerien = [];

  function galerie() {
    alle(document, '[data-flp-galerie]').forEach(function (g) {
      var band = g.querySelector('[data-flp-band]');
      if (!band) return;
      var minis = alle(g, '[data-flp-mini]');
      var bilder = alle(band, '.flp-galerie__bild');
      var zaehler = g.querySelector('[data-flp-zaehler]');
      var aktuell = 0;
      var gehe = function (i) {
        i = Math.max(0, Math.min(bilder.length - 1, i));
        band.scrollTo({ left: bilder[i].offsetLeft - band.offsetLeft, behavior: ruhig ? 'auto' : 'smooth' });
      };
      var markieren = function () {
        var breite = Math.max(1, bilder[0].getBoundingClientRect().width);
        var i = Math.round(band.scrollLeft / breite);
        i = Math.max(0, Math.min(bilder.length - 1, i));
        if (i === aktuell) return;
        aktuell = i;
        minis.forEach(function (m, n) { m.setAttribute('aria-current', n === i ? 'true' : 'false'); });
        if (zaehler) zaehler.textContent = String(i + 1);
        var m = minis[i];
        if (m && m.parentElement) {
          var reihe = m.parentElement;
          reihe.scrollTo({ left: m.offsetLeft - reihe.clientWidth / 2 + m.clientWidth / 2, behavior: ruhig ? 'auto' : 'smooth' });
        }
      };
      band.addEventListener('scroll', function () { window.requestAnimationFrame(markieren); }, { passive: true });
      minis.forEach(function (m, i) { m.addEventListener('click', function () { gehe(i); }); });
      var vor = g.querySelector('[data-flp-vor]');
      var zurueck = g.querySelector('[data-flp-zurueck]');
      if (vor) vor.addEventListener('click', function () { gehe(aktuell + 1 >= bilder.length ? 0 : aktuell + 1); });
      if (zurueck) zurueck.addEventListener('click', function () { gehe(aktuell - 1 < 0 ? bilder.length - 1 : aktuell - 1); });
      band.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); gehe(aktuell + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); gehe(aktuell - 1); }
      });
      galerien.push({
        wurzel: g,
        zuPosition: function (pos) {
          for (var i = 0; i < bilder.length; i++) {
            if (bilder[i].getAttribute('data-pos') === String(pos)) { gehe(i); return true; }
          }
          return false;
        }
      });
      lupe(g, bilder.filter(function (b) { return b.querySelector('img'); }));
    });
  }

  function lupe(g, bilder) {
    var sec = g.closest('.flp-kauf');
    var dlg = sec && sec.querySelector('[data-flp-lupe-dialog]');
    if (!dlg || typeof dlg.showModal !== 'function' || !bilder.length) return;
    var img = dlg.querySelector('[data-flp-lupe-bild]');
    var nr = 0;
    var zeigen = function (i) {
      nr = (i + bilder.length) % bilder.length;
      var fig = bilder[nr];
      var quelle = fig.querySelector('img');
      img.src = fig.getAttribute('data-gross') || (quelle && quelle.currentSrc) || '';
      img.alt = (quelle && quelle.alt) || '';
    };
    bilder.forEach(function (fig, i) {
      var knopf = fig.querySelector('[data-flp-lupe]');
      if (knopf) knopf.addEventListener('click', function () { zeigen(i); dlg.showModal(); });
    });
    dlg.querySelector('[data-flp-lupe-zu]').addEventListener('click', function () { dlg.close(); });
    dlg.querySelector('[data-flp-lupe-vor]').addEventListener('click', function () { zeigen(nr + 1); });
    dlg.querySelector('[data-flp-lupe-zurueck]').addEventListener('click', function () { zeigen(nr - 1); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') zeigen(nr + 1);
      if (e.key === 'ArrowLeft') zeigen(nr - 1);
    });
  }

  /* ---------- Lichtfarben im Kaufbereich ---------- */

  function farbwahl() {
    alle(document, '[data-flp-kauf]').forEach(function (sec) {
      var knoepfe = alle(sec, '[data-flp-farbe]');
      if (!knoepfe.length) return;
      var szene = sec.querySelector('[data-flp-szene]');
      var g = galerien.filter(function (x) { return sec.contains(x.wurzel); })[0];
      knoepfe.forEach(function (k) {
        k.addEventListener('click', function () {
          var modus = k.getAttribute('data-flp-farbe');
          knoepfe.forEach(function (x) { x.setAttribute('aria-pressed', String(x === k)); });
          if (szene) {
            szene.setAttribute('data-modus', modus);
            var lampe = szene.querySelector('.flp-lampe');
            if (lampe) lampe.setAttribute('data-modus', modus);
            var t = szene.querySelector('[data-flp-szene-titel]');
            var x = szene.querySelector('[data-flp-szene-text]');
            if (t && k.getAttribute('data-szene-titel')) t.textContent = k.getAttribute('data-szene-titel');
            if (x && k.getAttribute('data-szene-text')) x.textContent = k.getAttribute('data-szene-text');
            zuenden(szene);
            if (g) g.zuPosition('zeichnung');
          } else if (g) {
            g.zuPosition(k.getAttribute('data-bild'));
          }
        });
      });
    });
  }

  /* ---------- Auswahl ---------- */

  function kaufForm() { return document.querySelector('[data-flp-form]'); }

  function auswahlLesen() {
    var form = kaufForm();
    if (!form) return null;
    var h = form.querySelector('input[name="id"]');
    var anzahl = form.querySelector('[data-flp-anzahl]');
    var sec = form.closest('[data-flp-kauf]');
    return {
      id: h ? parseInt(h.value, 10) : 0,
      preis: sec ? parseInt(sec.getAttribute('data-preis'), 10) : 0,
      titel: sec ? sec.getAttribute('data-titel') : '',
      anzahl: anzahl ? Math.max(1, parseInt(anzahl.value, 10) || 1) : 1
    };
  }

  /* ---------- Warenkorb ---------- */

  function inDenWarenkorb(items) {
    var schublade = document.querySelector('cart-drawer');
    var body = { items: items };
    if (schublade && typeof schublade.getSectionsToRender === 'function') {
      body.sections = schublade.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (daten) {
        if (!res.ok || daten.status) throw new Error(daten.description || daten.message || 'HTTP ' + res.status);
        return daten;
      });
    }).then(function (daten) {
      try {
        if (schublade && typeof schublade.renderContents === 'function' && daten.sections) {
          schublade.classList.remove('is-empty');
          schublade.renderContents(daten);
        } else {
          window.location.href = root + 'cart';
        }
      } catch (e) {
        window.location.href = root + 'cart';
      }
      return daten;
    });
  }

  var HAKEN = '<svg class="flp-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4.5 12.5l4.8 4.8L19.5 7"/></svg>';

  function knopfLaeuft(btn, an) {
    if (!btn) return;
    if (an) {
      if (!btn.__flpLabel) btn.__flpLabel = btn.innerHTML;
      btn.disabled = true;
      btn.classList.add('ist-laeuft');
    } else {
      btn.disabled = false;
      btn.classList.remove('ist-laeuft');
      if (btn.__flpLabel) btn.innerHTML = btn.__flpLabel;
    }
  }

  function knopfOk(btn) {
    if (!btn) return;
    var label = btn.__flpLabel || btn.innerHTML;
    var kurz = !btn.querySelector('span');
    btn.disabled = false;
    btn.classList.remove('ist-laeuft');
    btn.classList.add('ist-ok');
    btn.innerHTML = HAKEN + (kurz ? '' : '<span>Im Warenkorb</span>');
    setTimeout(function () { btn.classList.remove('ist-ok'); btn.innerHTML = label; }, 2400);
  }

  function fehlerZeigen(el, err) {
    if (!el) return;
    el.hidden = false;
    el.textContent = (err && err.message) ? err.message : 'Das hat nicht geklappt. Bitte versuch es noch einmal oder ruf uns an.';
  }

  function stepper() {
    alle(document, '[data-flp-stepper]').forEach(function (st) {
      var feld = st.querySelector('input');
      var setzen = function (n) {
        var min = parseInt(feld.min || '1', 10), max = parseInt(feld.max || '999', 10);
        if (isNaN(n)) n = min;
        feld.value = Math.max(min, Math.min(max, n));
        feld.dispatchEvent(new Event('change', { bubbles: true }));
      };
      st.querySelector('[data-flp-minus]').addEventListener('click', function () { setzen(parseInt(feld.value, 10) - 1); });
      st.querySelector('[data-flp-plus]').addEventListener('click', function () { setzen(parseInt(feld.value, 10) + 1); });
      feld.addEventListener('blur', function () {
        var min = parseInt(feld.min || '1', 10), max = parseInt(feld.max || '999', 10);
        var n = parseInt(feld.value, 10);
        if (isNaN(n) || n < min || n > max) setzen(n);
      });
    });
  }

  function zusatz() {
    var form = kaufForm();
    if (!form) return;
    var box = form.querySelector('[data-flp-zusatz]');
    if (!box || !window.fetch) return;
    box.hidden = false;
    var check = box.querySelector('[data-flp-zusatz-check]');
    var summe = form.querySelector('[data-flp-zusatz-summe]');
    var betrag = form.querySelector('[data-flp-zusatz-betrag]');
    var anzahl = form.querySelector('[data-flp-anzahl]');
    function rechne() {
      box.classList.toggle('ist-an', check.checked);
      if (!summe) return;
      summe.hidden = !check.checked;
      if (!check.checked) return;
      var z = auswahlLesen();
      var p = z.preis * z.anzahl + parseInt(box.getAttribute('data-preis'), 10) * z.anzahl;
      betrag.textContent = geld(p);
      var menge = form.querySelector('[data-flp-zusatz-menge]');
      if (menge) menge.textContent = z.anzahl > 1 ? ' ' + z.anzahl + ' × ' + z.titel + ' und ' + z.anzahl + ' × ' + box.getAttribute('data-titel') : '';
      tick(summe);
    }
    check.addEventListener('change', rechne);
    if (anzahl) anzahl.addEventListener('change', rechne);
  }

  function mengen() {
    var form = kaufForm();
    var box = form && form.querySelector('[data-flp-mengen]');
    var feld = form && form.querySelector('[data-flp-anzahl]');
    if (!box || !feld) return;
    box.hidden = false;
    var karten = alle(box, '[data-flp-menge]');
    function markiere() {
      var n = parseInt(feld.value, 10) || 1;
      karten.forEach(function (k) { k.setAttribute('aria-pressed', String(parseInt(k.getAttribute('data-flp-menge'), 10) === n)); });
    }
    karten.forEach(function (k) {
      k.addEventListener('click', function () {
        feld.value = k.getAttribute('data-flp-menge');
        feld.dispatchEvent(new Event('change', { bubbles: true }));
        tick(k);
      });
    });
    feld.addEventListener('change', markiere);
    feld.addEventListener('input', markiere);
    markiere();
  }

  function kauf() {
    var form = kaufForm();
    if (!form || !window.fetch) return;
    var btn = form.querySelector('[data-flp-submit]');
    var fehler = form.querySelector('[data-flp-fehler]');
    form.addEventListener('submit', function (e) {
      if (e.submitter && e.submitter !== btn) return;
      e.preventDefault();
      var z = auswahlLesen();
      if (!z) return;
      var items = [{ id: z.id, quantity: z.anzahl }];
      var box = form.querySelector('[data-flp-zusatz]');
      var check = box && box.querySelector('[data-flp-zusatz-check]');
      if (check && check.checked) items.push({ id: parseInt(box.getAttribute('data-id'), 10), quantity: z.anzahl });
      if (fehler) { fehler.hidden = true; fehler.textContent = ''; }
      knopfLaeuft(btn, true);
      inDenWarenkorb(items).then(function () { knopfOk(btn); })
        .catch(function (err) { knopfLaeuft(btn, false); fehlerZeigen(fehler, err); });
    });
  }

  function direkt() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-flp-direkt]');
      if (!btn) return;
      e.preventDefault();
      var z = auswahlLesen();
      if (!z || !window.fetch) {
        var ziel = document.getElementById('kaufen');
        if (ziel) ziel.scrollIntoView({ behavior: ruhig ? 'auto' : 'smooth' });
        return;
      }
      knopfLaeuft(btn, true);
      inDenWarenkorb([{ id: z.id, quantity: 1 }]).then(function () { knopfOk(btn); })
        .catch(function () {
          knopfLaeuft(btn, false);
          var ziel = document.getElementById('kaufen');
          if (ziel) ziel.scrollIntoView({ behavior: ruhig ? 'auto' : 'smooth' });
        });
    });
  }

  function miniformen() {
    if (!window.fetch) return;
    alle(document, '[data-flp-miniform]').forEach(function (form) {
      var btn = form.querySelector('button[type="submit"]');
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var id = parseInt(form.querySelector('input[name="id"]').value, 10);
        var feld = form.querySelector('input[name="quantity"]');
        var n = feld ? parseInt(feld.value, 10) || 0 : 1;
        if (n < 1) { n = 1; if (feld) { feld.value = '1'; feld.dispatchEvent(new Event('change', { bubbles: true })); } }
        knopfLaeuft(btn, true);
        inDenWarenkorb([{ id: id, quantity: n }]).then(function () { knopfOk(btn); })
          .catch(function () { knopfLaeuft(btn, false); form.submit(); });
      });
    });
  }

  /* ---------- Einsatz-Duo ---------- */

  function duo() {
    if (!window.fetch) return;
    alle(document, '[data-flp-duo]').forEach(function (box) {
      var knopf = box.querySelector('[data-flp-duo-kauf]');
      if (!knopf) return;
      knopf.hidden = false;
      var fehler = box.querySelector('[data-flp-duo-fehler]');
      knopf.addEventListener('click', function () {
        if (fehler) fehler.hidden = true;
        knopfLaeuft(knopf, true);
        inDenWarenkorb([
          { id: parseInt(box.getAttribute('data-a-id'), 10), quantity: 1 },
          { id: parseInt(box.getAttribute('data-b-id'), 10), quantity: 1 }
        ]).then(function () { knopfOk(knopf); })
          .catch(function (err) { knopfLaeuft(knopf, false); fehlerZeigen(fehler, err); });
      });
    });
  }

  /* ---------- Baukasten ---------- */

  function baukasten() {
    alle(document, '[data-flp-baukasten]').forEach(function (box) {
      var felder = alle(box, '[data-flp-bk-anzahl]');
      var kasse = box.querySelector('[data-flp-bk-kasse]');
      if (!felder.length || !kasse) return;
      box.classList.add('flp-baukasten--live');
      kasse.hidden = false;
      felder.forEach(function (f) {
        f.min = '0';
        f.value = f.getAttribute('data-start') || '0';
      });
      var setze = function (sel, text) { var el = box.querySelector(sel); if (el) el.textContent = text; };
      function liste() {
        return felder.map(function (f) {
          return { id: parseInt(f.getAttribute('data-id'), 10), n: Math.max(0, parseInt(f.value, 10) || 0), preis: parseInt(f.getAttribute('data-preis'), 10), name: f.getAttribute('data-name') };
        }).filter(function (x) { return x.n > 0; });
      }
      function rechne(still) {
        var l = liste();
        var summe = l.reduce(function (s, x) { return s + x.n * x.preis; }, 0);
        var stueck = l.reduce(function (s, x) { return s + x.n; }, 0);
        felder.forEach(function (f) { f.closest('.flp-bk-zeile').classList.toggle('ist-gewaehlt', (parseInt(f.value, 10) || 0) > 0); });
        setze('[data-flp-bk-summe]', geld(summe));
        setze('[data-flp-bk-brutto]', geld(brutto(summe)));
        setze('[data-flp-bk-stueck]', stueck === 1 ? '1 Lampe gewählt' : stueck + ' Lampen gewählt');
        var k = box.querySelector('[data-flp-bk-kauf]');
        if (k) k.disabled = stueck === 0;
        if (!still) tick(box.querySelector('.flp-baukasten__summe'));
      }
      felder.forEach(function (f) { f.addEventListener('change', function () { rechne(); }); f.addEventListener('input', function () { rechne(); }); });
      rechne(true);
      var kauf = box.querySelector('[data-flp-bk-kauf]');
      var fehler = box.querySelector('[data-flp-bk-fehler]');
      if (kauf && window.fetch) {
        kauf.addEventListener('click', function () {
          var l = liste();
          if (!l.length) return;
          if (fehler) fehler.hidden = true;
          knopfLaeuft(kauf, true);
          inDenWarenkorb(l.map(function (x) { return { id: x.id, quantity: x.n }; }))
            .then(function () { knopfOk(kauf); })
            .catch(function (err) { knopfLaeuft(kauf, false); fehlerZeigen(fehler, err); });
        });
      }
      var angebot = box.querySelector('[data-flp-bk-angebot]');
      if (angebot) {
        angebot.addEventListener('click', function () {
          var l = liste();
          var stueck = l.reduce(function (s, x) { return s + x.n; }, 0);
          formularFuellen({
            anliegen: 'Angebot',
            ausfuehrung: 'Zusammenstellung aus dem Baukasten',
            anzahl: stueck || 1,
            text: 'Zusammenstellung: ' + (l.length ? l.map(function (x) { return x.n + ' × ' + x.name; }).join(', ') : 'noch offen') + '.',
            ersetzen: /^Zusammenstellung:[^\n]*/
          });
        });
      }
    });
  }

  /* ---------- Anfrage vorbefüllen ---------- */

  function formular() { return document.querySelector('[data-flp-formular]'); }

  function markieren(feld) {
    if (!feld || ruhig) return;
    var wrap = feld.closest('.flp-formular__feld');
    if (!wrap) return;
    wrap.classList.remove('ist-vorbefuellt');
    void wrap.offsetWidth;
    wrap.classList.add('ist-vorbefuellt');
    setTimeout(function () { wrap.classList.remove('ist-vorbefuellt'); }, 1600);
  }

  function formularFuellen(w) {
    var f = formular();
    if (!f) return;
    if (w.anliegen) {
      var sel = f.querySelector('[data-flp-f-anliegen]');
      if (sel) for (var i = 0; i < sel.options.length; i++) if (sel.options[i].value === w.anliegen) { sel.selectedIndex = i; break; }
    }
    var aus = f.querySelector('[data-flp-f-ausfuehrung]');
    if (aus) {
      var ziel = w.ausfuehrung || '';
      var treffer = -1;
      for (var j = 0; j < aus.options.length; j++) {
        var t = aus.options[j].getAttribute('data-titel') || '';
        if (ziel && (t === ziel || t.indexOf(ziel) === 0)) { treffer = j; break; }
      }
      if (treffer < 0 && !ziel) treffer = 0;
      if (treffer >= 0 && aus.selectedIndex !== treffer) { aus.selectedIndex = treffer; markieren(aus); }
    }
    if (w.anzahl) {
      var anz = f.querySelector('[data-flp-f-anzahl]');
      if (anz) { anz.value = String(w.anzahl); markieren(anz); }
    }
    if (w.text) {
      var text = f.querySelector('[data-flp-f-text]');
      if (text) {
        var muster = w.ersetzen || /^(Einsatzbereich|Einsatz-Duo|Zusammenstellung):[^\n]*/;
        if (muster.test(text.value)) text.value = text.value.replace(muster, w.text);
        else text.value = w.text + (text.value ? '\n' + text.value : '');
        markieren(text);
      }
    }
  }

  function anliegen() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-flp-anliegen]');
      if (!a) return;
      var w = { anliegen: a.getAttribute('data-flp-anliegen') };
      if (a.hasAttribute('data-flp-mit-auswahl')) {
        var z = auswahlLesen();
        if (z) w.anzahl = z.anzahl;
      }
      if (a.getAttribute('data-flp-ausfuehrung')) w.ausfuehrung = a.getAttribute('data-flp-ausfuehrung');
      if (a.getAttribute('data-flp-text')) w.text = a.getAttribute('data-flp-text');
      formularFuellen(w);
    });
  }

  /* ---------- Einsatzbereiche: Reiter ---------- */

  function weiche() {
    alle(document, '[data-flp-weiche]').forEach(function (sec) {
      var reiter = sec.querySelector('[data-flp-reiter]');
      var knoepfe = alle(sec, '[data-flp-reiter-knopf]');
      var felder = alle(sec, '[data-flp-feld]');
      if (!reiter || !knoepfe.length) return;
      reiter.hidden = false;
      sec.classList.add('flp-einsatz--live');
      function waehle(i, fokus) {
        knoepfe.forEach(function (k, n) {
          var an = n === i;
          k.setAttribute('aria-selected', String(an));
          k.tabIndex = an ? 0 : -1;
        });
        felder.forEach(function (f, n) {
          f.hidden = n !== i;
          if (n === i && !ruhig) einmal(f, 'flp-wechsel', 900);
        });
        if (fokus) knoepfe[i].focus();
      }
      knoepfe.forEach(function (k, i) {
        k.addEventListener('click', function () { waehle(i); });
        k.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); waehle((i + 1) % knoepfe.length, true); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); waehle((i - 1 + knoepfe.length) % knoepfe.length, true); }
        });
      });
      felder.forEach(function (f, n) { f.hidden = n !== 0; });
    });
  }

  /* ---------- Lichtbühne ---------- */

  function licht() {
    alle(document, '[data-flp-licht]').forEach(function (sec) {
      var buehne = sec.querySelector('[data-flp-licht-buehne]');
      var lampe = buehne && buehne.querySelector('.flp-lampe');
      var tasten = alle(sec, '[data-flp-modus]');
      var dimmer = sec.querySelector('[data-flp-dimmer]');
      var regler = sec.querySelector('[data-flp-dimm]');
      var ausgabe = sec.querySelector('[data-flp-dimm-wert]');
      var wort = sec.querySelector('[data-flp-l-wort]');
      var text = sec.querySelector('[data-flp-l-text]');
      if (!buehne || !tasten.length) return;
      var min = parseFloat(sec.getAttribute('data-dimm-min')) || 150;
      var max = parseFloat(sec.getAttribute('data-dimm-max')) || 500;
      var weiteMax = parseFloat(sec.getAttribute('data-weite-max')) || 0;
      var lzHell = sec.getAttribute('data-laufzeit-hell') || '';
      var lzDunkel = sec.getAttribute('data-laufzeit-dunkel') || '';
      var aktiv = tasten[0];
      var setze = function (key, wert) {
        var el = sec.querySelector('[data-flp-l="' + key + '"]');
        if (el && el.textContent !== wert) { el.textContent = wert; tick(el); }
      };
      if (dimmer && regler) dimmer.hidden = false;

      function dimmWerte() {
        var lm = parseFloat(regler.value) || max;
        var anteil = (lm - min) / Math.max(1, max - min);
        buehne.style.setProperty('--hell', (0.35 + 0.65 * anteil).toFixed(3));
        if (ausgabe) ausgabe.textContent = zahlFmt.format(lm) + ' lm';
        setze('leistung', zahlFmt.format(lm) + '\u00a0lm · ' + (lm >= max ? '' : 'bis ') + zahlFmt.format(weiteMax) + '\u00a0m');
        if (lm >= max) setze('laufzeit', lzHell);
        else if (lm <= min) setze('laufzeit', lzDunkel);
        else setze('laufzeit', lzHell + ' bis ' + lzDunkel);
      }

      function zeigen(t, still) {
        aktiv = t;
        var modus = t.getAttribute('data-flp-modus');
        tasten.forEach(function (x) { x.setAttribute('aria-pressed', String(x === t)); });
        buehne.setAttribute('data-modus', modus);
        if (lampe) lampe.setAttribute('data-modus', modus);
        if (wort && wort.textContent !== t.getAttribute('data-wort')) { wort.textContent = t.getAttribute('data-wort') || ''; if (!still) einmal(wort, 'flp-go', 900); }
        if (text && text.textContent !== t.getAttribute('data-text')) { text.textContent = t.getAttribute('data-text') || ''; if (!still) tick(text); }
        var weiss = modus === 'weiss';
        if (dimmer) dimmer.classList.toggle('ist-aus', !weiss);
        if (regler) regler.disabled = !weiss;
        setze('quelle', t.getAttribute('data-quelle') || '');
        if (weiss && regler) dimmWerte();
        else {
          buehne.style.setProperty('--hell', '1');
          setze('leistung', t.getAttribute('data-leistung') || '');
          setze('laufzeit', t.getAttribute('data-laufzeit') || '');
        }
        if (!still) zuenden(buehne);
      }
      tasten.forEach(function (t) { t.addEventListener('click', function () { zeigen(t); }); });
      if (regler) regler.addEventListener('input', function () { if (aktiv.getAttribute('data-flp-modus') === 'weiss') dimmWerte(); });
      zeigen(aktiv, true);

      if (!ruhig && hatIO) {
        var io = new IntersectionObserver(function (e) {
          if (!e[0].isIntersecting) return;
          io.disconnect();
          zuenden(buehne);
        }, { threshold: 0.45 });
        io.observe(buehne);
      }
    });
  }

  /* ---------- Scroll-Geschichte ---------- */

  function wandel() {
    alle(document, '[data-flp-wandel]').forEach(function (sec) {
      var buehne = sec.querySelector('[data-flp-w-buehne]');
      var schritte = alle(sec, '[data-flp-w-schritt]');
      var punkte = alle(sec, '[data-flp-w-punkt]');
      var lampe = buehne && buehne.querySelector('.flp-lampe');
      var wort = sec.querySelector('[data-flp-w-wort]');
      if (!buehne || !schritte.length || !hatIO) return;
      var mq = window.matchMedia('(min-width: 990px)');
      var io = null;
      var aktivNr = '';
      function aktiv(s) {
        var nr = s.getAttribute('data-flp-w-schritt');
        if (nr === aktivNr) return;
        var modusAlt = buehne.getAttribute('data-modus');
        aktivNr = nr;
        schritte.forEach(function (x) { x.classList.toggle('ist-aktiv', x === s); });
        punkte.forEach(function (p) { p.classList.toggle('ist-aktiv', p.getAttribute('data-flp-w-punkt') === nr); });
        var modus = s.getAttribute('data-modus');
        buehne.setAttribute('data-modus', modus);
        buehne.setAttribute('data-pose', s.getAttribute('data-pose'));
        if (lampe) lampe.setAttribute('data-modus', modus);
        if (wort) wort.textContent = s.getAttribute('data-wort') || '';
        if (modus !== modusAlt) zuenden(buehne);
      }
      function an() {
        sec.classList.add('flp-wandel--live');
        io = new IntersectionObserver(function (eintraege) {
          eintraege.forEach(function (e) { if (e.isIntersecting) aktiv(e.target); });
        }, { rootMargin: '-45% 0px -45% 0px' });
        schritte.forEach(function (s) { io.observe(s); });
      }
      function aus() {
        sec.classList.remove('flp-wandel--live');
        if (io) { io.disconnect(); io = null; }
      }
      function pruefen() { if (mq.matches) { if (!io) an(); } else aus(); }
      if (mq.addEventListener) mq.addEventListener('change', pruefen); else if (mq.addListener) mq.addListener(pruefen);
      pruefen();
    });
  }

  /* ---------- Familie: Finder ---------- */

  function finder() {
    alle(document, '[data-flp-familie]').forEach(function (sec) {
      var f = sec.querySelector('[data-flp-finder]');
      if (!f) return;
      f.hidden = false;
      var knoepfe = alle(f, '[data-flp-filter]');
      var modelle = alle(sec, '[data-flp-modell]');
      knoepfe.forEach(function (k) {
        k.addEventListener('click', function () {
          var schluessel = k.getAttribute('data-flp-filter');
          knoepfe.forEach(function (x) { x.setAttribute('aria-pressed', String(x === k)); });
          modelle.forEach(function (m) {
            var tags = ' ' + (m.getAttribute('data-tags') || '') + ' ';
            var trifft = !schluessel || tags.indexOf(' ' + schluessel + ' ') >= 0;
            m.classList.toggle('ist-leise', !trifft);
            m.classList.toggle('ist-treffer', !!schluessel && trifft);
            if (schluessel && trifft) einmal(m, 'flp-hebt', 700);
          });
        });
      });
    });
  }

  /* ---------- Liefertermin ---------- */

  function termin() {
    alle(document, '[data-flp-termin]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10), max = parseInt(el.getAttribute('data-max'), 10);
      if (!min || !max) return;
      var plus = function (n) {
        var d = new Date();
        d.setHours(12, 0, 0, 0);
        while (n > 0) {
          d.setDate(d.getDate() + 1);
          var t = d.getDay();
          if (t !== 0 && t !== 6) n--;
        }
        return d;
      };
      var fmt = new Intl.DateTimeFormat('de-DE', { weekday: 'short', day: '2-digit', month: '2-digit' });
      var von = el.querySelector('[data-flp-termin-von]');
      var bis = el.querySelector('[data-flp-termin-bis]');
      if (von) von.textContent = fmt.format(plus(min));
      if (bis) bis.textContent = fmt.format(plus(max));
      el.hidden = false;
    });
  }

  /* ---------- Kaufleiste ---------- */

  function leiste() {
    var st = document.querySelector('[data-flp-sticky]');
    var form = kaufForm();
    if (!st) return;
    var kontakt = document.getElementById('ContactForm');
    var fuss = document.querySelector('footer, .footer, #shopify-section-footer, .footer-group');
    var sichtbar = function (el) {
      if (!el) return false;
      var r = el.getBoundingClientRect();
      return r.bottom > 0 && r.top < vh();
    };
    var geplant = false;

    function pruefen() {
      geplant = false;
      // Erst nach dem Kaufbereich: der Warenkorb-Button ist dann nach oben aus dem Bild
      var vorbei = form ? form.getBoundingClientRect().bottom < 0 : window.scrollY > 600;
      var zeigen = vorbei && !sichtbar(kontakt) && !sichtbar(fuss);
      if (zeigen) {
        if (st.hidden) {
          st.hidden = false;
          st.classList.add('ist-weg');
          requestAnimationFrame(function () { requestAnimationFrame(function () { st.classList.remove('ist-weg'); st.classList.add('aktiv'); }); });
        } else { st.classList.remove('ist-weg'); st.classList.add('aktiv'); }
      } else if (!st.hidden) {
        st.classList.add('ist-weg');
        st.classList.remove('aktiv');
      }
      document.body.classList.toggle('flp-leiste-an', zeigen);
    }
    window.addEventListener('scroll', function () {
      if (geplant) return;
      geplant = true;
      requestAnimationFrame(pruefen);
    }, { passive: true });
    window.addEventListener('resize', pruefen, { passive: true });
    pruefen();

    var knopf = st.querySelector('[data-flp-sticky-kauf]');
    if (knopf && form && window.fetch) {
      knopf.addEventListener('click', function (e) {
        e.preventDefault();
        var z = auswahlLesen();
        if (!z) return;
        knopfLaeuft(knopf, true);
        inDenWarenkorb([{ id: z.id, quantity: z.anzahl }]).then(function () { knopfOk(knopf); })
          .catch(function () {
            knopfLaeuft(knopf, false);
            var ziel = document.getElementById('kaufen');
            if (ziel) ziel.scrollIntoView({ behavior: ruhig ? 'auto' : 'smooth' });
          });
      });
    }
  }

  /* ---------- Start ---------- */

  function start() {
    stepper();
    kleben();
    galerie();
    farbwahl();
    mengen();
    zusatz();
    kauf();
    direkt();
    miniformen();
    duo();
    baukasten();
    anliegen();
    weiche();
    licht();
    wandel();
    finder();
    termin();
    einblenden();
    zaehlen();
    leiste();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
